var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.984 511.984",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.995,490.657c-5.906,0-10.672,4.78-10.672,10.671s4.766,10.656,10.672,10.656 c5.875,0,10.655-4.766,10.655-10.656S165.87,490.657,159.995,490.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,490.657c-5.891,0-10.672,4.78-10.672,10.671s4.781,10.656,10.672,10.656 s10.672-4.766,10.672-10.656S187.213,490.657,181.322,490.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M191.994,501.328c0,5.891,4.766,10.656,10.655,10.656c5.891,0,10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671C196.76,490.657,191.994,495.437,191.994,501.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M234.649,501.328c0,5.891,4.78,10.656,10.671,10.656s10.672-4.765,10.672-10.656 s-4.781-10.671-10.672-10.671S234.649,495.437,234.649,501.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,490.657c-5.891,0-10.672,4.78-10.672,10.671s4.781,10.656,10.672,10.656 s10.656-4.766,10.656-10.656S293.882,490.657,287.991,490.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.99,501.328c0,5.891,4.765,10.656,10.655,10.656s10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671S319.99,495.437,319.99,501.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,511.984c5.891,0,10.656-4.766,10.656-10.656s-4.766-10.671-10.656-10.671 s-10.672,4.78-10.672,10.671S346.098,511.984,351.989,511.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M394.643,490.657c-5.891,0-10.655,4.78-10.655,10.671s4.765,10.656,10.655,10.656 s10.672-4.766,10.672-10.656S400.534,490.657,394.643,490.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,501.328c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656 s-4.766-10.671-10.656-10.671S405.315,495.437,405.315,501.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M437.315,511.984c5.89,0,10.671-4.766,10.671-10.656s-4.781-10.671-10.671-10.671 c-5.891,0-10.672,4.78-10.672,10.671S431.425,511.984,437.315,511.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M469.313,501.328c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656 s-4.766-10.671-10.656-10.671S469.313,495.437,469.313,501.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,479.985c0-5.89-4.78-10.655-10.655-10.655c-5.906,0-10.672,4.766-10.672,10.655 c0,5.906,4.766,10.672,10.672,10.672C165.87,490.657,170.65,485.891,170.65,479.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,469.33c-5.89,0-10.655,4.766-10.655,10.655c0,5.906,4.766,10.672,10.655,10.672 c5.891,0,10.672-4.766,10.672-10.672C213.321,474.096,208.54,469.33,202.649,469.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,469.33c-5.906,0-10.672,4.766-10.672,10.655c0,5.906,4.766,10.672,10.672,10.672 c5.891,0,10.656-4.766,10.656-10.672C234.649,474.096,229.884,469.33,223.993,469.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,469.33c-5.891,0-10.671,4.766-10.671,10.655c0,5.906,4.78,10.672,10.671,10.672 s10.672-4.766,10.672-10.672C255.992,474.096,251.211,469.33,245.32,469.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.992,479.985c0,5.906,4.765,10.672,10.655,10.672s10.672-4.766,10.672-10.672 c0-5.89-4.781-10.655-10.672-10.655S255.992,474.096,255.992,479.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,479.985c0,5.906,4.78,10.672,10.671,10.672s10.672-4.766,10.672-10.672 c0-5.89-4.781-10.655-10.672-10.655S298.647,474.096,298.647,479.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,490.657c5.891,0,10.672-4.766,10.672-10.672c0-5.89-4.781-10.655-10.672-10.655 s-10.655,4.766-10.655,10.655C319.99,485.891,324.755,490.657,330.645,490.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M373.316,469.33c-5.89,0-10.671,4.766-10.671,10.655c0,5.906,4.781,10.672,10.671,10.672 c5.891,0,10.672-4.766,10.672-10.672C383.988,474.096,379.207,469.33,373.316,469.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,479.985c0-5.89-4.781-10.655-10.672-10.655s-10.655,4.766-10.655,10.655 c0,5.906,4.765,10.672,10.655,10.672S405.315,485.891,405.315,479.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,479.985c0,5.906,4.781,10.672,10.672,10.672s10.656-4.766,10.656-10.672 c0-5.89-4.766-10.655-10.656-10.655S405.315,474.096,405.315,479.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,469.33c-5.89,0-10.655,4.766-10.655,10.655c0,5.906,4.766,10.672,10.655,10.672 c5.891,0,10.672-4.766,10.672-10.672C469.313,474.096,464.532,469.33,458.641,469.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,479.985c0-5.89-4.766-10.655-10.656-10.655s-10.672,4.766-10.672,10.655 c0,5.906,4.781,10.672,10.672,10.672S490.641,485.891,490.641,479.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,447.986c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.672,10.672,10.672 s10.672-4.781,10.672-10.672S187.213,447.986,181.322,447.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,458.658c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 s4.766,10.672,10.655,10.672C208.54,469.33,213.321,464.549,213.321,458.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.647,447.986c-5.891,0-10.655,4.781-10.655,10.672s4.765,10.672,10.655,10.672 s10.672-4.781,10.672-10.672S272.538,447.986,266.647,447.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,458.658c0,5.891,4.781,10.672,10.672,10.672s10.656-4.781,10.656-10.672 s-4.766-10.672-10.656-10.672S277.319,452.767,277.319,458.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M309.318,469.33c5.891,0,10.672-4.781,10.672-10.672s-4.781-10.672-10.672-10.672 s-10.671,4.781-10.671,10.672S303.428,469.33,309.318,469.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,447.986c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.672,10.672,10.672 s10.656-4.781,10.656-10.672S357.88,447.986,351.989,447.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M383.988,458.658c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.671,4.781-10.671,10.672 s4.781,10.672,10.671,10.672C379.207,469.33,383.988,464.549,383.988,458.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,458.658c0,5.891,4.781,10.672,10.672,10.672s10.656-4.781,10.656-10.672 s-4.766-10.672-10.656-10.672S405.315,452.767,405.315,458.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M469.313,458.658c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 s4.766,10.672,10.655,10.672C464.532,469.33,469.313,464.549,469.313,458.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,458.658c0,5.891,4.781,10.672,10.672,10.672c5.89,0,10.671-4.781,10.671-10.672 s-4.781-10.672-10.671-10.672S490.641,452.767,490.641,458.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.995,426.659c-5.906,0-10.672,4.78-10.672,10.671s4.766,10.656,10.672,10.656 c5.875,0,10.655-4.766,10.655-10.656S165.87,426.659,159.995,426.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M191.994,437.33c0-5.891-4.781-10.671-10.672-10.671s-10.672,4.78-10.672,10.671 s4.781,10.656,10.672,10.656S191.994,443.221,191.994,437.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,447.986c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.671-10.672-10.671 c-5.89,0-10.655,4.78-10.655,10.671S196.76,447.986,202.649,447.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,437.33c0-5.891-4.781-10.671-10.672-10.671s-10.655,4.78-10.655,10.671 s4.765,10.656,10.655,10.656S277.319,443.221,277.319,437.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,437.33c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656 s-4.766-10.671-10.656-10.671S277.319,431.439,277.319,437.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,426.659c-5.891,0-10.655,4.78-10.655,10.671s4.765,10.656,10.655,10.656 s10.672-4.766,10.672-10.656S336.536,426.659,330.645,426.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M469.313,437.33c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656 s-4.766-10.671-10.656-10.671S469.313,431.439,469.313,437.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M501.313,447.986c5.89,0,10.671-4.766,10.671-10.656s-4.781-10.671-10.671-10.671 c-5.891,0-10.672,4.78-10.672,10.671S495.423,447.986,501.313,447.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,415.987c0-5.89-4.78-10.655-10.655-10.655c-5.906,0-10.672,4.766-10.672,10.655 c0,5.906,4.766,10.672,10.672,10.672C165.87,426.659,170.65,421.893,170.65,415.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,415.987c0-5.89-4.781-10.655-10.672-10.655c-5.89,0-10.655,4.766-10.655,10.655 c0,5.906,4.766,10.672,10.655,10.672C208.54,426.659,213.321,421.893,213.321,415.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,426.659c5.891,0,10.656-4.766,10.656-10.672c0-5.89-4.766-10.655-10.656-10.655 c-5.906,0-10.672,4.766-10.672,10.655C213.321,421.893,218.087,426.659,223.993,426.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,415.987c0-5.89-4.781-10.655-10.672-10.655s-10.655,4.765-10.655,10.655 c0,5.906,4.765,10.672,10.655,10.672S277.319,421.893,277.319,415.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,415.987c0,5.906,4.781,10.672,10.672,10.672s10.656-4.766,10.656-10.672 c0-5.89-4.766-10.655-10.656-10.655S277.319,410.097,277.319,415.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M341.317,415.987c0-5.89-4.781-10.655-10.672-10.655s-10.655,4.766-10.655,10.655 c0,5.906,4.765,10.672,10.655,10.672S341.317,421.893,341.317,415.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M469.313,415.987c0,5.906,4.781,10.672,10.672,10.672s10.656-4.766,10.656-10.672 c0-5.89-4.766-10.655-10.656-10.655S469.313,410.097,469.313,415.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,394.66c0-5.891-4.78-10.672-10.655-10.672c-5.906,0-10.672,4.781-10.672,10.672 s4.766,10.672,10.672,10.672C165.87,405.332,170.65,400.551,170.65,394.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,394.66c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 s4.766,10.672,10.655,10.672C208.54,405.332,213.321,400.551,213.321,394.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M234.649,394.66c0,5.891,4.78,10.672,10.671,10.672s10.672-4.781,10.672-10.672 s-4.781-10.672-10.672-10.672S234.649,388.769,234.649,394.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,383.988c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.672,10.672,10.672 s10.656-4.781,10.656-10.672S293.882,383.988,287.991,383.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,394.66c0,5.891,4.78,10.672,10.671,10.672s10.672-4.781,10.672-10.672 s-4.781-10.672-10.672-10.672S298.647,388.769,298.647,394.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,383.988c-5.89,0-10.655,4.781-10.655,10.672s4.766,10.672,10.655,10.672 c5.891,0,10.672-4.781,10.672-10.672S464.532,383.988,458.641,383.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M479.985,383.988c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.672,10.672,10.672 s10.656-4.781,10.656-10.672S485.876,383.988,479.985,383.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,394.66c0,5.891,4.781,10.672,10.672,10.672c5.89,0,10.671-4.781,10.671-10.672 s-4.781-10.672-10.671-10.672S490.641,388.769,490.641,394.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,362.66c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.656,10.672,10.656 s10.672-4.766,10.672-10.656S187.213,362.66,181.322,362.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,373.332c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 s4.766,10.656,10.655,10.656C208.54,383.988,213.321,379.222,213.321,373.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,373.332c0,5.891,4.766,10.656,10.672,10.656c5.891,0,10.656-4.766,10.656-10.656 s-4.766-10.672-10.656-10.672C218.087,362.66,213.321,367.441,213.321,373.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,383.988c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.672-10.672-10.672 s-10.671,4.781-10.671,10.672S239.43,383.988,245.32,383.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.647,383.988c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672S260.757,383.988,266.647,383.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M309.318,362.66c-5.891,0-10.671,4.781-10.671,10.672s4.78,10.656,10.671,10.656 s10.672-4.766,10.672-10.656S315.209,362.66,309.318,362.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,362.66c-5.891,0-10.655,4.781-10.655,10.672s4.765,10.656,10.655,10.656 s10.672-4.766,10.672-10.656S336.536,362.66,330.645,362.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,383.988c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.672-10.672-10.672 c-5.89,0-10.655,4.781-10.655,10.672S452.752,383.988,458.641,383.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M511.984,373.332c0-5.891-4.781-10.672-10.671-10.672c-5.891,0-10.672,4.781-10.672,10.672 s4.781,10.656,10.672,10.656C507.203,383.988,511.984,379.222,511.984,373.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M10.655,341.333C4.764,341.333,0,346.099,0,351.989c0,5.906,4.765,10.671,10.655,10.671 s10.672-4.765,10.672-10.671C21.327,346.098,16.546,341.333,10.655,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M31.999,341.333c-5.906,0-10.672,4.766-10.672,10.656c0,5.906,4.766,10.671,10.672,10.671 c5.874,0,10.655-4.765,10.655-10.671C42.654,346.098,37.873,341.333,31.999,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M42.654,351.989c0,5.906,4.781,10.671,10.672,10.671s10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656S42.654,346.098,42.654,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M85.325,351.989c0,5.906,4.766,10.671,10.672,10.671c5.874,0,10.655-4.765,10.655-10.671 c0-5.891-4.781-10.656-10.655-10.656C90.091,341.333,85.325,346.098,85.325,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M127.996,351.989c0,5.906,4.766,10.671,10.655,10.671c5.891,0,10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656C132.762,341.333,127.996,346.098,127.996,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.995,362.66c5.875,0,10.655-4.765,10.655-10.671c0-5.891-4.78-10.656-10.655-10.656 c-5.906,0-10.672,4.766-10.672,10.656C149.323,357.895,154.089,362.66,159.995,362.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,351.989c0-5.891-4.781-10.656-10.672-10.656c-5.89,0-10.655,4.766-10.655,10.656 c0,5.906,4.766,10.671,10.655,10.671C208.54,362.66,213.321,357.895,213.321,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,351.989c0,5.906,4.766,10.671,10.672,10.671c5.891,0,10.656-4.765,10.656-10.671 c0-5.891-4.766-10.656-10.656-10.656C218.087,341.333,213.321,346.098,213.321,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,351.989c0-5.891-4.781-10.656-10.672-10.656s-10.655,4.765-10.655,10.656 c0,5.906,4.765,10.671,10.655,10.671S277.319,357.895,277.319,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M341.317,351.989c0-5.891-4.781-10.656-10.672-10.656s-10.655,4.766-10.655,10.656 c0,5.906,4.765,10.671,10.655,10.671S341.317,357.895,341.317,351.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M479.985,362.66c5.891,0,10.656-4.765,10.656-10.671c0-5.891-4.766-10.656-10.656-10.656 s-10.672,4.766-10.672,10.656C469.313,357.895,474.095,362.66,479.985,362.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M21.327,330.662c0-5.891-4.781-10.672-10.672-10.672S0,324.771,0,330.662 s4.765,10.671,10.655,10.671S21.327,336.553,21.327,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M42.654,330.662c0,5.891,4.781,10.671,10.672,10.671s10.672-4.78,10.672-10.671 s-4.781-10.672-10.672-10.672S42.654,324.771,42.654,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M85.325,330.662c0,5.891,4.766,10.671,10.672,10.671c5.874,0,10.655-4.78,10.655-10.671 s-4.781-10.672-10.655-10.672C90.091,319.99,85.325,324.771,85.325,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M127.996,330.662c0,5.891,4.766,10.671,10.655,10.671c5.891,0,10.672-4.78,10.672-10.671 s-4.781-10.672-10.672-10.672C132.762,319.99,127.996,324.771,127.996,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,319.99c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.671,10.672,10.671 s10.672-4.78,10.672-10.671S187.213,319.99,181.322,319.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,330.662c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 s4.766,10.671,10.655,10.671C208.54,341.333,213.321,336.553,213.321,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,341.333c5.891,0,10.656-4.78,10.656-10.671s-4.766-10.672-10.656-10.672 c-5.906,0-10.672,4.781-10.672,10.672S218.087,341.333,223.993,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,330.662c0-5.891-4.781-10.672-10.672-10.672s-10.655,4.781-10.655,10.672 s4.765,10.671,10.655,10.671S277.319,336.553,277.319,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,330.662c0,5.891,4.78,10.671,10.671,10.671s10.672-4.78,10.672-10.671 s-4.781-10.672-10.672-10.672S298.647,324.771,298.647,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M383.988,330.662c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.671,4.781-10.671,10.672 s4.781,10.671,10.671,10.671C379.207,341.333,383.988,336.553,383.988,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M394.643,341.333c5.891,0,10.672-4.78,10.672-10.671s-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672S388.753,341.333,394.643,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M447.986,330.662c0-5.891-4.781-10.672-10.671-10.672c-5.891,0-10.672,4.781-10.672,10.672 s4.781,10.671,10.672,10.671C443.205,341.333,447.986,336.553,447.986,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,341.333c5.891,0,10.672-4.78,10.672-10.671s-4.781-10.672-10.672-10.672 c-5.89,0-10.655,4.781-10.655,10.672S452.752,341.333,458.641,341.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,330.662c0,5.891,4.781,10.671,10.672,10.671c5.89,0,10.671-4.78,10.671-10.671 s-4.781-10.672-10.671-10.672C495.423,319.99,490.641,324.771,490.641,330.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M21.327,309.334c0-5.891-4.781-10.672-10.672-10.672S0,303.443,0,309.334 s4.765,10.656,10.655,10.656S21.327,315.224,21.327,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M53.326,298.662c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.656,10.672,10.656 s10.672-4.766,10.672-10.656S59.217,298.662,53.326,298.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M74.653,298.662c-5.891,0-10.655,4.781-10.655,10.672s4.765,10.656,10.655,10.656 s10.672-4.766,10.672-10.656S80.544,298.662,74.653,298.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M95.997,298.662c-5.906,0-10.672,4.781-10.672,10.672s4.766,10.656,10.672,10.656 c5.874,0,10.655-4.766,10.655-10.656S101.871,298.662,95.997,298.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M117.324,298.662c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.656,10.672,10.656 c5.891,0,10.672-4.766,10.672-10.656S123.215,298.662,117.324,298.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M138.651,298.662c-5.89,0-10.655,4.781-10.655,10.672s4.766,10.656,10.655,10.656 c5.891,0,10.672-4.766,10.672-10.656S144.542,298.662,138.651,298.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.323,309.334c0,5.891,4.766,10.656,10.672,10.656c5.875,0,10.655-4.766,10.655-10.656 s-4.78-10.672-10.655-10.672C154.089,298.662,149.323,303.443,149.323,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M234.649,309.334c0-5.891-4.766-10.672-10.656-10.672c-5.906,0-10.672,4.781-10.672,10.672 s4.766,10.656,10.672,10.656C229.884,319.99,234.649,315.224,234.649,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,309.334c0-5.891-4.781-10.672-10.672-10.672s-10.655,4.781-10.655,10.672 s4.765,10.656,10.655,10.656S277.319,315.224,277.319,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,309.334c0,5.891,4.78,10.656,10.671,10.656s10.672-4.766,10.672-10.656 s-4.781-10.672-10.672-10.672S298.647,303.443,298.647,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,319.99c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672S324.755,319.99,330.645,319.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,309.334c0-5.891-4.781-10.672-10.672-10.672s-10.655,4.781-10.655,10.672 s4.765,10.656,10.655,10.656S405.315,315.224,405.315,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M447.986,309.334c0-5.891-4.781-10.672-10.671-10.672c-5.891,0-10.672,4.781-10.672,10.672 s4.781,10.656,10.672,10.656C443.205,319.99,447.986,315.224,447.986,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,309.334c0,5.891,4.781,10.656,10.672,10.656c5.89,0,10.671-4.766,10.671-10.656 s-4.781-10.672-10.671-10.672S490.641,303.443,490.641,309.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M31.999,277.335c-5.906,0-10.672,4.766-10.672,10.656c0,5.906,4.766,10.671,10.672,10.671 c5.874,0,10.655-4.765,10.655-10.671C42.654,282.1,37.873,277.335,31.999,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M63.998,287.991c0-5.891-4.781-10.656-10.672-10.656s-10.672,4.766-10.672,10.656 c0,5.906,4.781,10.671,10.672,10.671S63.998,293.897,63.998,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M106.652,287.991c0,5.906,4.781,10.671,10.672,10.671c5.891,0,10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656C111.433,277.335,106.652,282.1,106.652,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.995,277.335c-5.906,0-10.672,4.766-10.672,10.656c0,5.906,4.766,10.671,10.672,10.671 c5.875,0,10.655-4.765,10.655-10.671C170.65,282.1,165.87,277.335,159.995,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,287.991c0,5.906,4.781,10.671,10.672,10.671s10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656S170.65,282.1,170.65,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M234.649,287.991c0,5.906,4.78,10.671,10.671,10.671s10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656S234.649,282.1,234.649,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,277.335c-5.891,0-10.672,4.766-10.672,10.656c0,5.906,4.781,10.671,10.672,10.671 s10.656-4.765,10.656-10.671C298.647,282.1,293.882,277.335,287.991,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,287.991c0,5.906,4.78,10.671,10.671,10.671s10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656S298.647,282.1,298.647,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M373.316,277.335c-5.89,0-10.671,4.766-10.671,10.656c0,5.906,4.781,10.671,10.671,10.671 c5.891,0,10.672-4.765,10.672-10.671C383.988,282.1,379.207,277.335,373.316,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,287.991c0-5.891-4.781-10.656-10.672-10.656s-10.655,4.766-10.655,10.656 c0,5.906,4.765,10.671,10.655,10.671S405.315,293.897,405.315,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M415.987,298.662c5.891,0,10.656-4.765,10.656-10.671c0-5.891-4.766-10.656-10.656-10.656 s-10.672,4.766-10.672,10.656C405.315,293.897,410.096,298.662,415.987,298.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,277.335c-5.89,0-10.655,4.766-10.655,10.656c0,5.906,4.766,10.671,10.655,10.671 c5.891,0,10.672-4.765,10.672-10.671C469.313,282.1,464.532,277.335,458.641,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M479.985,277.335c-5.891,0-10.672,4.766-10.672,10.656c0,5.906,4.781,10.671,10.672,10.671 s10.656-4.765,10.656-10.671C490.641,282.1,485.876,277.335,479.985,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M511.984,287.991c0-5.891-4.781-10.656-10.671-10.656c-5.891,0-10.672,4.766-10.672,10.656 c0,5.906,4.781,10.671,10.672,10.671C507.203,298.662,511.984,293.897,511.984,287.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M10.655,255.992C4.764,255.992,0,260.773,0,266.664c0,5.89,4.765,10.671,10.655,10.671 s10.672-4.781,10.672-10.671C21.327,260.773,16.546,255.992,10.655,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M42.654,266.664c0-5.891-4.781-10.672-10.655-10.672c-5.906,0-10.672,4.781-10.672,10.672 c0,5.89,4.766,10.671,10.672,10.671C37.873,277.335,42.654,272.554,42.654,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M53.326,255.992c-5.891,0-10.672,4.781-10.672,10.672c0,5.89,4.781,10.671,10.672,10.671 s10.672-4.781,10.672-10.671C63.998,260.773,59.217,255.992,53.326,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M74.653,255.992c-5.891,0-10.655,4.781-10.655,10.672c0,5.89,4.765,10.671,10.655,10.671 s10.672-4.781,10.672-10.671C85.325,260.773,80.544,255.992,74.653,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M95.997,255.992c-5.906,0-10.672,4.781-10.672,10.672c0,5.89,4.766,10.671,10.672,10.671 c5.874,0,10.655-4.781,10.655-10.671C106.652,260.773,101.871,255.992,95.997,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M106.652,266.664c0,5.89,4.781,10.671,10.672,10.671c5.891,0,10.672-4.781,10.672-10.671 c0-5.891-4.781-10.672-10.672-10.672C111.433,255.992,106.652,260.773,106.652,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M138.651,277.335c5.891,0,10.672-4.781,10.672-10.671c0-5.891-4.781-10.672-10.672-10.672 c-5.89,0-10.655,4.781-10.655,10.672C127.996,272.554,132.762,277.335,138.651,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,266.664c0,5.89,4.781,10.671,10.672,10.671s10.672-4.781,10.672-10.671 c0-5.891-4.781-10.672-10.672-10.672S170.65,260.773,170.65,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,277.335c5.891,0,10.672-4.781,10.672-10.671c0-5.891-4.781-10.672-10.672-10.672 c-5.89,0-10.655,4.781-10.655,10.672C191.994,272.554,196.76,277.335,202.649,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,277.335c5.891,0,10.656-4.781,10.656-10.671c0-5.891-4.766-10.672-10.656-10.672 c-5.906,0-10.672,4.781-10.672,10.672C213.321,272.554,218.087,277.335,223.993,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,277.335c5.891,0,10.672-4.781,10.672-10.671c0-5.891-4.781-10.672-10.672-10.672 s-10.671,4.781-10.671,10.672C234.649,272.554,239.43,277.335,245.32,277.335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,266.664c0-5.891-4.766-10.672-10.656-10.672s-10.672,4.781-10.672,10.672 c0,5.89,4.781,10.671,10.672,10.671S298.647,272.554,298.647,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,266.664c0,5.89,4.78,10.671,10.671,10.671s10.672-4.781,10.672-10.671 c0-5.891-4.781-10.672-10.672-10.672S298.647,260.773,298.647,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,255.992c-5.891,0-10.672,4.781-10.672,10.672c0,5.89,4.781,10.671,10.672,10.671 s10.656-4.781,10.656-10.671C362.645,260.773,357.88,255.992,351.989,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M383.988,266.664c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.671,4.781-10.671,10.672 c0,5.89,4.781,10.671,10.671,10.671C379.207,277.335,383.988,272.554,383.988,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M426.643,266.664c0,5.89,4.781,10.671,10.672,10.671c5.89,0,10.671-4.781,10.671-10.671 c0-5.891-4.781-10.672-10.671-10.672S426.643,260.773,426.643,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,266.664c0-5.891-4.766-10.672-10.656-10.672s-10.672,4.781-10.672,10.672 c0,5.89,4.781,10.671,10.672,10.671S490.641,272.554,490.641,266.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M21.327,245.336c0-5.891-4.781-10.671-10.672-10.671S0,239.445,0,245.336 s4.764,10.656,10.655,10.656S21.327,251.226,21.327,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M31.999,255.992c5.874,0,10.655-4.766,10.655-10.656s-4.781-10.671-10.655-10.671 c-5.906,0-10.672,4.78-10.672,10.671S26.093,255.992,31.999,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M85.325,245.336c0-5.891-4.781-10.671-10.672-10.671c-5.891,0-10.655,4.78-10.655,10.671 s4.765,10.656,10.655,10.656S85.325,251.226,85.325,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M106.652,245.336c0,5.891,4.781,10.656,10.672,10.656c5.891,0,10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671C111.433,234.665,106.652,239.445,106.652,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.323,245.336c0,5.891,4.766,10.656,10.672,10.656c5.875,0,10.655-4.766,10.655-10.656 s-4.78-10.671-10.655-10.671C154.089,234.665,149.323,239.445,149.323,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,245.336c0,5.891,4.781,10.656,10.672,10.656s10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671S170.65,239.445,170.65,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,245.336c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656 s-4.766-10.671-10.656-10.671S277.319,239.445,277.319,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M309.318,255.992c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.671-10.672-10.671 s-10.671,4.78-10.671,10.671S303.428,255.992,309.318,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M362.645,245.336c0-5.891-4.766-10.671-10.656-10.671s-10.672,4.78-10.672,10.671 s4.781,10.656,10.672,10.656S362.645,251.226,362.645,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M394.643,234.665c-5.891,0-10.655,4.78-10.655,10.671s4.765,10.656,10.655,10.656 s10.672-4.766,10.672-10.656S400.534,234.665,394.643,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,245.336c0,5.891,4.781,10.656,10.672,10.656s10.656-4.766,10.656-10.656 s-4.766-10.671-10.656-10.671S405.315,239.445,405.315,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M437.315,255.992c5.89,0,10.671-4.766,10.671-10.656s-4.781-10.671-10.671-10.671 c-5.891,0-10.672,4.78-10.672,10.671S431.425,255.992,437.315,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,255.992c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.671-10.672-10.671 c-5.89,0-10.655,4.78-10.655,10.671S452.752,255.992,458.641,255.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,245.336c0,5.891,4.781,10.656,10.672,10.656c5.89,0,10.671-4.766,10.671-10.656 s-4.781-10.671-10.671-10.671C495.423,234.665,490.641,239.445,490.641,245.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M42.654,223.993c0-5.891-4.781-10.656-10.655-10.656c-5.906,0-10.672,4.766-10.672,10.656 c0,5.906,4.766,10.672,10.672,10.672C37.873,234.665,42.654,229.899,42.654,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M53.326,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 s-10.672,4.766-10.672,10.656C42.654,229.899,47.435,234.665,53.326,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M74.653,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 c-5.891,0-10.655,4.766-10.655,10.656C63.998,229.899,68.763,234.665,74.653,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M95.997,234.665c5.874,0,10.655-4.766,10.655-10.672c0-5.891-4.781-10.656-10.655-10.656 c-5.906,0-10.672,4.766-10.672,10.656C85.325,229.899,90.091,234.665,95.997,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M117.324,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 c-5.891,0-10.672,4.766-10.672,10.656C106.652,229.899,111.433,234.665,117.324,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M138.651,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 c-5.89,0-10.655,4.766-10.655,10.656C127.996,229.899,132.762,234.665,138.651,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.323,223.993c0,5.906,4.766,10.672,10.672,10.672c5.875,0,10.655-4.766,10.655-10.672 c0-5.891-4.78-10.656-10.655-10.656C154.089,213.337,149.323,218.102,149.323,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 s-10.672,4.766-10.672,10.656C170.65,229.899,175.431,234.665,181.322,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 c-5.89,0-10.655,4.766-10.655,10.656C191.994,229.899,196.76,234.665,202.649,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,234.665c5.891,0,10.656-4.766,10.656-10.672c0-5.891-4.766-10.656-10.656-10.656 c-5.906,0-10.672,4.766-10.672,10.656C213.321,229.899,218.087,234.665,223.993,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.647,213.337c-5.891,0-10.655,4.766-10.655,10.656c0,5.906,4.765,10.672,10.655,10.672 s10.672-4.766,10.672-10.672C277.319,218.102,272.538,213.337,266.647,213.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,223.993c0,5.906,4.781,10.672,10.672,10.672s10.656-4.766,10.656-10.672 c0-5.891-4.766-10.656-10.656-10.656S277.319,218.102,277.319,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M362.645,223.993c0-5.891-4.766-10.656-10.656-10.656s-10.672,4.766-10.672,10.656 c0,5.906,4.781,10.672,10.672,10.672S362.645,229.899,362.645,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M373.316,234.665c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 c-5.89,0-10.671,4.766-10.671,10.656C362.645,229.899,367.427,234.665,373.316,234.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M405.315,223.993c0,5.906,4.781,10.672,10.672,10.672s10.656-4.766,10.656-10.672 c0-5.891-4.766-10.656-10.656-10.656S405.315,218.102,405.315,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M469.313,223.993c0-5.891-4.781-10.656-10.672-10.656c-5.89,0-10.655,4.766-10.655,10.656 c0,5.906,4.766,10.672,10.655,10.672C464.532,234.665,469.313,229.899,469.313,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,223.993c0,5.906,4.781,10.672,10.672,10.672c5.89,0,10.671-4.766,10.671-10.672 c0-5.891-4.781-10.656-10.671-10.656S490.641,218.102,490.641,223.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M0,202.666c0,5.89,4.765,10.671,10.655,10.671s10.672-4.781,10.672-10.671 c0-5.891-4.781-10.672-10.672-10.672S0,196.775,0,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M63.998,202.666c0-5.891-4.781-10.672-10.672-10.672s-10.672,4.781-10.672,10.672 c0,5.89,4.781,10.671,10.672,10.671S63.998,208.555,63.998,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.323,202.666c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 c0,5.89,4.766,10.671,10.655,10.671C144.542,213.337,149.323,208.555,149.323,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.323,202.666c0,5.89,4.766,10.671,10.672,10.671c5.875,0,10.655-4.781,10.655-10.671 c0-5.891-4.78-10.672-10.655-10.672C154.089,191.994,149.323,196.775,149.323,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,202.666c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.655,4.781-10.655,10.672 c0,5.89,4.766,10.671,10.655,10.671C208.54,213.337,213.321,208.555,213.321,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,202.666c0-5.891-4.781-10.672-10.672-10.672s-10.655,4.781-10.655,10.672 c0,5.89,4.765,10.671,10.655,10.671S277.319,208.555,277.319,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,191.994c-5.891,0-10.672,4.781-10.672,10.672c0,5.89,4.781,10.671,10.672,10.671 s10.656-4.781,10.656-10.671C298.647,196.775,293.882,191.994,287.991,191.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,202.666c0,5.89,4.78,10.671,10.671,10.671s10.672-4.781,10.672-10.671 c0-5.891-4.781-10.672-10.672-10.672S298.647,196.775,298.647,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,213.337c5.891,0,10.672-4.781,10.672-10.671c0-5.891-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672C319.99,208.555,324.755,213.337,330.645,213.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M383.988,202.666c0-5.891-4.781-10.672-10.672-10.672c-5.89,0-10.671,4.781-10.671,10.672 c0,5.89,4.781,10.671,10.671,10.671C379.207,213.337,383.988,208.555,383.988,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M394.643,213.337c5.891,0,10.672-4.781,10.672-10.671c0-5.891-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672C383.988,208.555,388.753,213.337,394.643,213.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M415.987,213.337c5.891,0,10.656-4.781,10.656-10.671c0-5.891-4.766-10.672-10.656-10.672 s-10.672,4.781-10.672,10.672C405.315,208.555,410.096,213.337,415.987,213.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M437.315,213.337c5.89,0,10.671-4.781,10.671-10.671c0-5.891-4.781-10.672-10.671-10.672 c-5.891,0-10.672,4.781-10.672,10.672C426.643,208.555,431.425,213.337,437.315,213.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M490.641,202.666c0,5.89,4.781,10.671,10.672,10.671c5.89,0,10.671-4.781,10.671-10.671 c0-5.891-4.781-10.672-10.671-10.672S490.641,196.775,490.641,202.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M10.655,170.667C4.764,170.667,0,175.447,0,181.338s4.765,10.656,10.655,10.656 s10.672-4.766,10.672-10.656S16.546,170.667,10.655,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M21.327,181.338c0,5.891,4.766,10.656,10.672,10.656c5.874,0,10.655-4.766,10.655-10.656 s-4.781-10.671-10.655-10.671C26.093,170.667,21.327,175.447,21.327,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M63.998,181.338c0,5.891,4.765,10.656,10.655,10.656s10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671C68.762,170.667,63.998,175.447,63.998,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M117.324,170.667c-5.891,0-10.672,4.78-10.672,10.671s4.781,10.656,10.672,10.656 c5.891,0,10.672-4.766,10.672-10.656S123.215,170.667,117.324,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M149.323,181.338c0-5.891-4.781-10.671-10.672-10.671c-5.89,0-10.655,4.78-10.655,10.671 s4.766,10.656,10.655,10.656C144.542,191.994,149.323,187.228,149.323,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.995,170.667c-5.906,0-10.672,4.78-10.672,10.671s4.766,10.656,10.672,10.656 c5.875,0,10.655-4.766,10.655-10.656S165.87,170.667,159.995,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,181.338c0,5.891,4.781,10.656,10.672,10.656s10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671S170.65,175.447,170.65,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,170.667c-5.906,0-10.672,4.78-10.672,10.671s4.766,10.656,10.672,10.656 c5.891,0,10.656-4.766,10.656-10.656S229.884,170.667,223.993,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,170.667c-5.891,0-10.671,4.78-10.671,10.671s4.78,10.656,10.671,10.656 s10.672-4.766,10.672-10.656S251.211,170.667,245.32,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M277.319,181.338c0-5.891-4.781-10.671-10.672-10.671s-10.655,4.78-10.655,10.671 s4.765,10.656,10.655,10.656S277.319,187.228,277.319,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,181.338c0,5.891,4.78,10.656,10.671,10.656s10.672-4.766,10.672-10.656 s-4.781-10.671-10.672-10.671S298.647,175.447,298.647,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,170.667c-5.891,0-10.672,4.78-10.672,10.671s4.781,10.656,10.672,10.656 s10.656-4.766,10.656-10.656S357.88,170.667,351.989,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M383.988,181.338c0-5.891-4.781-10.671-10.672-10.671c-5.89,0-10.671,4.78-10.671,10.671 s4.781,10.656,10.671,10.656C379.207,191.994,383.988,187.228,383.988,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M447.986,181.338c0-5.891-4.781-10.671-10.671-10.671c-5.891,0-10.672,4.78-10.672,10.671 s4.781,10.656,10.672,10.656C443.205,191.994,447.986,187.228,447.986,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M458.641,191.994c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.671-10.672-10.671 c-5.89,0-10.655,4.78-10.655,10.671S452.752,191.994,458.641,191.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M511.984,181.338c0-5.891-4.781-10.671-10.671-10.671c-5.891,0-10.672,4.78-10.672,10.671 s4.781,10.656,10.672,10.656C507.203,191.994,511.984,187.228,511.984,181.338z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M31.999,149.339c-5.906,0-10.672,4.766-10.672,10.656c0,5.906,4.766,10.672,10.672,10.672 c5.874,0,10.655-4.766,10.655-10.672C42.654,154.104,37.873,149.339,31.999,149.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M53.326,149.339c-5.891,0-10.672,4.766-10.672,10.656c0,5.906,4.781,10.672,10.672,10.672 s10.672-4.766,10.672-10.672C63.998,154.104,59.217,149.339,53.326,149.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M74.653,149.339c-5.891,0-10.655,4.766-10.655,10.656c0,5.906,4.765,10.672,10.655,10.672 s10.672-4.766,10.672-10.672C85.325,154.104,80.544,149.339,74.653,149.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M95.997,149.339c-5.906,0-10.672,4.766-10.672,10.656c0,5.906,4.766,10.672,10.672,10.672 c5.874,0,10.655-4.766,10.655-10.672C106.652,154.104,101.871,149.339,95.997,149.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M127.996,159.995c0-5.891-4.781-10.656-10.672-10.656c-5.891,0-10.672,4.766-10.672,10.656 c0,5.906,4.781,10.672,10.672,10.672C123.215,170.667,127.996,165.901,127.996,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,159.995c0-5.891-4.78-10.656-10.655-10.656c-5.906,0-10.672,4.766-10.672,10.656 c0,5.906,4.766,10.672,10.672,10.672C165.87,170.667,170.65,165.901,170.65,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,149.339c-5.891,0-10.672,4.766-10.672,10.656c0,5.906,4.781,10.672,10.672,10.672 s10.672-4.766,10.672-10.672C191.994,154.104,187.213,149.339,181.322,149.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M191.994,159.995c0,5.906,4.766,10.672,10.655,10.672c5.891,0,10.672-4.766,10.672-10.672 c0-5.891-4.781-10.656-10.672-10.656C196.76,149.339,191.994,154.104,191.994,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.992,159.995c0-5.891-4.781-10.656-10.672-10.656s-10.671,4.766-10.671,10.656 c0,5.906,4.78,10.672,10.671,10.672S255.992,165.901,255.992,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.647,170.667c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 s-10.655,4.765-10.655,10.656C255.992,165.901,260.757,170.667,266.647,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,170.667c5.891,0,10.656-4.766,10.656-10.672c0-5.891-4.766-10.656-10.656-10.656 s-10.672,4.766-10.672,10.656C277.319,165.901,282.1,170.667,287.991,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,159.995c0,5.906,4.78,10.672,10.671,10.672s10.672-4.766,10.672-10.672 c0-5.891-4.781-10.656-10.672-10.656S298.647,154.104,298.647,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M362.645,159.995c0-5.891-4.766-10.656-10.656-10.656s-10.672,4.766-10.672,10.656 c0,5.906,4.781,10.672,10.672,10.672S362.645,165.901,362.645,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M373.316,170.667c5.891,0,10.672-4.766,10.672-10.672c0-5.891-4.781-10.656-10.672-10.656 c-5.89,0-10.671,4.766-10.671,10.656C362.645,165.901,367.427,170.667,373.316,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M415.987,149.339c-5.891,0-10.672,4.766-10.672,10.656c0,5.906,4.781,10.672,10.672,10.672 s10.656-4.766,10.656-10.672C426.643,154.104,421.878,149.339,415.987,149.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M447.986,159.995c0-5.891-4.781-10.656-10.671-10.656c-5.891,0-10.672,4.766-10.672,10.656 c0,5.906,4.781,10.672,10.672,10.672C443.205,170.667,447.986,165.901,447.986,159.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M479.985,170.667c5.891,0,10.656-4.766,10.656-10.672c0-5.891-4.766-10.656-10.656-10.656 s-10.672,4.766-10.672,10.656C469.313,165.901,474.095,170.667,479.985,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,138.667c0-5.89-4.78-10.671-10.655-10.671c-5.906,0-10.672,4.781-10.672,10.671 c0,5.891,4.766,10.672,10.672,10.672C165.87,149.339,170.65,144.557,170.65,138.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,127.996c-5.89,0-10.655,4.781-10.655,10.671c0,5.891,4.766,10.672,10.655,10.672 c5.891,0,10.672-4.781,10.672-10.672C213.321,132.777,208.54,127.996,202.649,127.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,127.996c-5.906,0-10.672,4.781-10.672,10.671c0,5.891,4.766,10.672,10.672,10.672 c5.891,0,10.656-4.781,10.656-10.672C234.649,132.777,229.884,127.996,223.993,127.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.992,138.667c0-5.89-4.781-10.671-10.672-10.671s-10.671,4.781-10.671,10.671 c0,5.891,4.78,10.672,10.671,10.672S255.992,144.557,255.992,138.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M309.318,127.996c-5.891,0-10.671,4.781-10.671,10.671c0,5.891,4.78,10.672,10.671,10.672 s10.672-4.781,10.672-10.672C319.99,132.777,315.209,127.996,309.318,127.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,127.996c-5.891,0-10.655,4.781-10.655,10.671c0,5.891,4.765,10.672,10.655,10.672 s10.672-4.781,10.672-10.672C341.317,132.777,336.536,127.996,330.645,127.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M362.645,138.667c0-5.89-4.766-10.671-10.656-10.671s-10.672,4.781-10.672,10.671 c0,5.891,4.781,10.672,10.672,10.672S362.645,144.557,362.645,138.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,117.34c0-5.891-4.78-10.672-10.655-10.672c-5.906,0-10.672,4.781-10.672,10.672 s4.766,10.656,10.672,10.656C165.87,127.996,170.65,123.23,170.65,117.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,117.34c0,5.891,4.781,10.656,10.672,10.656s10.672-4.766,10.672-10.656 s-4.781-10.672-10.672-10.672S170.65,111.449,170.65,117.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,106.668c-5.891,0-10.671,4.781-10.671,10.672s4.78,10.656,10.671,10.656 s10.672-4.766,10.672-10.656S251.211,106.668,245.32,106.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.992,117.34c0,5.891,4.765,10.656,10.655,10.656s10.672-4.766,10.672-10.656 s-4.781-10.672-10.672-10.672S255.992,111.449,255.992,117.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,127.996c5.891,0,10.656-4.766,10.656-10.656s-4.766-10.672-10.656-10.672 s-10.672,4.781-10.672,10.672S282.1,127.996,287.991,127.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M341.317,117.34c0-5.891-4.781-10.672-10.672-10.672s-10.655,4.781-10.655,10.672 s4.765,10.656,10.655,10.656S341.317,123.23,341.317,117.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,95.997c0-5.891-4.78-10.656-10.655-10.656c-5.906,0-10.672,4.766-10.672,10.656 c0,5.906,4.766,10.671,10.672,10.671C165.87,106.668,170.65,101.903,170.65,95.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,106.668c5.891,0,10.672-4.765,10.672-10.671c0-5.891-4.781-10.656-10.672-10.656 s-10.672,4.766-10.672,10.656C170.65,101.903,175.431,106.668,181.322,106.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,106.668c5.891,0,10.672-4.765,10.672-10.671c0-5.891-4.781-10.656-10.672-10.656 c-5.89,0-10.655,4.766-10.655,10.656C191.994,101.903,196.76,106.668,202.649,106.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,106.668c5.891,0,10.656-4.765,10.656-10.671c0-5.891-4.766-10.656-10.656-10.656 c-5.906,0-10.672,4.766-10.672,10.656C213.321,101.903,218.087,106.668,223.993,106.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.992,95.997c0,5.906,4.765,10.671,10.655,10.671s10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656S255.992,90.106,255.992,95.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M298.647,95.997c0,5.906,4.78,10.671,10.671,10.671s10.672-4.765,10.672-10.671 c0-5.891-4.781-10.656-10.672-10.656S298.647,90.106,298.647,95.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,85.341c-5.891,0-10.672,4.766-10.672,10.656c0,5.906,4.781,10.671,10.672,10.671 s10.656-4.765,10.656-10.671C362.645,90.106,357.88,85.341,351.989,85.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M234.649,74.669c0-5.89-4.766-10.671-10.656-10.671c-5.906,0-10.672,4.781-10.672,10.671 c0,5.891,4.766,10.672,10.672,10.672C229.884,85.341,234.649,80.559,234.649,74.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,63.998c-5.891,0-10.671,4.781-10.671,10.671c0,5.891,4.78,10.672,10.671,10.672 s10.672-4.782,10.672-10.672S251.211,63.998,245.32,63.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.992,74.669c0,5.891,4.765,10.672,10.655,10.672s10.672-4.781,10.672-10.672 c0-5.89-4.781-10.671-10.672-10.671S255.992,68.779,255.992,74.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,85.341c5.891,0,10.656-4.781,10.656-10.672c0-5.89-4.766-10.671-10.656-10.671 s-10.672,4.781-10.672,10.671S282.1,85.341,287.991,85.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M309.318,85.341c5.891,0,10.672-4.781,10.672-10.672c0-5.89-4.781-10.671-10.672-10.671 s-10.671,4.781-10.671,10.671S303.428,85.341,309.318,85.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.99,74.669c0,5.891,4.765,10.672,10.655,10.672s10.672-4.781,10.672-10.672 c0-5.89-4.781-10.671-10.672-10.671S319.99,68.779,319.99,74.669z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M159.995,42.67c-5.906,0-10.672,4.781-10.672,10.672s4.766,10.656,10.672,10.656 c5.875,0,10.655-4.766,10.655-10.656S165.87,42.67,159.995,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,42.67c-5.891,0-10.672,4.781-10.672,10.672s4.781,10.656,10.672,10.656 s10.672-4.766,10.672-10.656S187.213,42.67,181.322,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,42.67c-5.89,0-10.655,4.781-10.655,10.672s4.766,10.656,10.655,10.656 c5.891,0,10.672-4.766,10.672-10.656S208.54,42.67,202.649,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M234.649,53.342c0-5.891-4.766-10.672-10.656-10.672c-5.906,0-10.672,4.781-10.672,10.672 s4.766,10.656,10.672,10.656C229.884,63.998,234.649,59.232,234.649,53.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M245.32,63.998c5.891,0,10.672-4.766,10.672-10.656S251.211,42.67,245.32,42.67 s-10.671,4.781-10.671,10.672S239.43,63.998,245.32,63.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.647,63.998c5.891,0,10.672-4.766,10.672-10.656s-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672S260.757,63.998,266.647,63.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.99,53.342c0-5.891-4.781-10.672-10.672-10.672s-10.671,4.781-10.671,10.672 s4.78,10.656,10.671,10.656S319.99,59.232,319.99,53.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.99,53.342c0,5.891,4.765,10.656,10.655,10.656s10.672-4.766,10.672-10.656 s-4.781-10.672-10.672-10.672S319.99,47.451,319.99,53.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,63.998c5.891,0,10.656-4.766,10.656-10.656s-4.766-10.672-10.656-10.672 s-10.672,4.781-10.672,10.672S346.098,63.998,351.989,63.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,31.999c0-5.891-4.78-10.656-10.655-10.656c-5.906,0-10.672,4.766-10.672,10.656 c0,5.905,4.766,10.671,10.672,10.671C165.87,42.67,170.65,37.904,170.65,31.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M181.322,42.67c5.891,0,10.672-4.766,10.672-10.671c0-5.891-4.781-10.656-10.672-10.656 s-10.672,4.766-10.672,10.656C170.65,37.904,175.431,42.67,181.322,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M202.649,42.67c5.891,0,10.672-4.766,10.672-10.671c0-5.891-4.781-10.656-10.672-10.656 c-5.89,0-10.655,4.766-10.655,10.656C191.994,37.904,196.76,42.67,202.649,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M223.993,42.67c5.891,0,10.656-4.766,10.656-10.671c0-5.891-4.766-10.656-10.656-10.656 c-5.906,0-10.672,4.766-10.672,10.656C213.321,37.904,218.087,42.67,223.993,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.99,31.999c0-5.891-4.781-10.656-10.672-10.656s-10.671,4.766-10.671,10.656 c0,5.905,4.78,10.671,10.671,10.671S319.99,37.904,319.99,31.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M330.645,42.67c5.891,0,10.672-4.766,10.672-10.671c0-5.891-4.781-10.656-10.672-10.656 s-10.655,4.766-10.655,10.656C319.99,37.904,324.755,42.67,330.645,42.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M170.65,10.671C170.65,4.78,165.87,0,159.995,0c-5.906,0-10.672,4.78-10.672,10.671 s4.766,10.672,10.672,10.672C165.87,21.343,170.65,16.561,170.65,10.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M213.321,10.671C213.321,4.78,208.54,0,202.649,0c-5.89,0-10.655,4.78-10.655,10.671 s4.766,10.672,10.655,10.672C208.54,21.343,213.321,16.561,213.321,10.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M266.647,0c-5.891,0-10.655,4.78-10.655,10.671s4.765,10.672,10.655,10.672 s10.672-4.781,10.672-10.672S272.538,0,266.647,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M287.991,0c-5.891,0-10.672,4.78-10.672,10.671s4.781,10.672,10.672,10.672 s10.656-4.781,10.656-10.672S293.882,0,287.991,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M319.99,10.671C319.99,4.78,315.209,0,309.318,0s-10.671,4.78-10.671,10.671 s4.78,10.672,10.671,10.672S319.99,16.561,319.99,10.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M351.989,21.343c5.891,0,10.656-4.781,10.656-10.672S357.879,0,351.989,0 s-10.672,4.78-10.672,10.671S346.098,21.343,351.989,21.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M127.996,0H0v127.996h127.996V0z M106.652,106.668H21.327V21.343h85.325 C106.652,21.343,106.652,106.668,106.652,106.668z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.002,
    y: 32.002,
    style: {
      fill: "#656D78"
    },
    width: 63.998,
    height: 63.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M0,511.984h127.996V383.988H0V511.984z M21.327,405.332h85.325v85.325H21.327V405.332z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.002,
    y: 415.992,
    style: {
      fill: "#656D78"
    },
    width: 63.998,
    height: 63.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M383.988,0v127.996h127.996V0H383.988z M490.641,106.668h-85.326V21.343h85.326V106.668z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.992,
    y: 32.002,
    style: {
      fill: "#656D78"
    },
    width: 63.998,
    height: 63.998
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M447.986,341.333h-10.671h-42.672h-21.327h-31.999v10.656v21.343v42.655v21.343v10.656h10.672h21.327 h42.671h31.999V394.66v-21.328V341.333z M426.643,426.659h-63.998V362.66h63.998V426.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#656D78"
    },
    d: "M394.643,405.332c5.891,0,10.672-4.781,10.672-10.672s-4.781-10.672-10.672-10.672 s-10.655,4.781-10.655,10.672S388.753,405.332,394.643,405.332z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.3a3bea0e527c28644034e87ee7135d5c.svg";
export { ForwardRef as ReactComponent };